<template>
<div class="form">
<a-card title="告警记录编辑">
        <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        
        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">

           <a-form-model-item ref="syscode" label="所属系统" prop="syscode">
                <a-select  v-if="is_vue_task"   show-search placeholder="请选择" @change="handleChange">
                    <a-select-option v-for="(item,index) in syslist" :key="index" v-model="item.syscode">
                    {{item.sysname + '【' + item.syscode + '】'}}
                    </a-select-option>
                </a-select>
                <span class="form_span" >{{record.syscode}}</span>
            </a-form-model-item>
            <a-form-model-item label="系统名" prop="sysname" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="record.sysname" type="textarea" />
            </a-form-model-item>
            <a-form-model-item label="用户名" prop="username" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="record.username" type="textarea" />
            </a-form-model-item>

           <a-form-model-item label="手机号" prop="telephone" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="record.telephone" type="textarea" />
            </a-form-model-item>

            <a-form-model-item label="邮箱" prop="email" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="record.email" type="textarea" />
            </a-form-model-item>

           <a-form-model-item ref="groupid" label="选择分组" prop="groupid">
                    <div>
                        <commonselecter :modalState="modalState" @onModalHide="handleSelecterHide"></commonselecter>
                        <a-button @click="handleSelecterShow">选择分组</a-button>
                    </div>
                    <!-- 权限列表 -->
                    <a-table :columns="columns_role1" :data-source="groupids" :loading="tLoading1" :pagination="false"
                             rowKey="groupid">
                    </a-table>
          </a-form-model-item>

            <a-form-model-item   :wrapper-col="{ span: 14, offset: 10 }" >
                <a-button type="primary" @click="handleOk">
                    保存
                 </a-button>

                <a-button style="margin-left: 10px;" @click="handleCancel">
                    取消
                </a-button>
            </a-form-model-item>
        </a-form-model>

 </a-card>
</div>
  
</template>
<script>
import { mapState } from "vuex";
import commonselecter from '../../components/CommonSelecter'
const columns_role1 = [
    {
        title: '分组编码',
        dataIndex: 'groupid',
        align: 'center',
        width: 150
    },
    {
        title: '分组名称',
        dataIndex: 'groupname',
        align: 'center',
        width: 150
    }
];
export default {
    data() {
        return {
            is_vue_task : false,
            columns_role1,
            modalState: {
                title: '选择分组',//选择器标题
                isShow: false,
                rowsType: 'checkbox',//checkbox 多选  radio 单选
                selectkeys: undefined,
                filterAppcode: "groupid",//已选择key数组  [123,456]
                keyname: 'keyword',//唯一主键key
                // searchKey: 'rolecode',//搜索条件键值
                sc_params: {},
                selectedRowKeys: [],
                requestType: 'alarmmanager/searchGroupPage',
                columns: [
                    {
                        title: '分组编码',
                        dataIndex: 'groupid',
                        align: 'center',
                    },
                    {
                        title: '分组名称',
                        dataIndex: 'groupname',
                        align: 'center',
                    }
                ]
            },
            labelCol: {span: 3},
            wrapperCol: {span: 14},
            rules: {
                name: [
                    {required: true, message: '请输入分组名称', trigger: 'blur'},
                    {max: 50, message: '不能超过50位', trigger: 'blur'},
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            syslist:[],
            grouplist:[],
            groupids:[],
            tLoading1:false,
            actiontype:''
        };
    },
    computed: {
        ...mapState("alarmmanager", {
            record: function(state) {
                console.log("this.a====>"+this.actiontype);
                return this.actiontype == "useradd" ? {
                    syscode: '', 
                    sysname: '',
                    telephone: '',
                    username: ''
                } : state.record;
            }
        })
    },

    methods: {
        handleOk() {
            this.confirmLoading = true;
            if (this.actiontype == "useradd"){
               
                //新增
                this.$store
                    .dispatch({
                        type: "alarmmanager/useradd" ,
                        params: this.record
                    })
                    .then((response) => {
                        if (response.data.success == '1') {
                            this.$router.push({
                                path: "userlist"
                            });
                        }

                    });
            }else{
                //编辑
                this.record.id = this.record.id;
                this.$store
                    .dispatch({
                        type: "alarmmanager/useredit",
                        params: this.record
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            console.log(response)
                            this.handleCancel();
                            this.confirmLoading = false;
                        }
                    });
            }   
            
        },

        getSearchGroupList() {
            let c_params = {
                urlparams: false,
                pageSize: 9999,
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "alarmmanager/searchGroupPage",
                params: c_params
            }).then((res) => {
                console.log(res);
                this.grouplist = res.data.data;
                this.groupdata();
            })
        },
        
        groupdata() {
            let groupids = []
            let that = this
            let group= that.grouplist.list
            let groupids_ =that.record.groupid.split(",")
            for (let id of groupids_) { 
                let groupidlists = group.filter((item) => {
                    if (item.groupid == id) {
                        return item;
                    }
                });
                if (groupidlists.length > 0) {
                    groupids.push(groupidlists[0])
                }
            }
            that.tLoading1 = true
            that.groupids = groupids
            that.tLoading1 = false
        },

        handleChange(value) {
            this.record.syscode=value;
        },
        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

        handleSelecterShow() {
            this.selectedRowKeys = this.record.groupid ? [this.record.groupid] : [];
            this.modalState.selectkeys = this.record.groupid ? this.record.groupid.split(",") : [];
            this.modalState.isShow = true;
        },
        handleSelecterHide: function (result) {
            this.modalState.isShow = false;
            console.log(result)
            if (result) {
                let resultStr = []
                for (let index = 0; index < result.length; index++) {
                    resultStr.push(result[index].groupid)
                }
                this.record.groupids = resultStr.join(",")
                this.tLoading1 = true
                this.groupids = result
                this.tLoading1 = false
            }

        },
    },

    mounted(){
        const {query, params} = this.$route;
        this.is_vue_task = params.action == 'useradd';
        //页面加载完成-接口获取系统列表
        this.$store.dispatch({
            type: "sys/sysSelecter",
        }).then((res)=>{
            this.syslist = res.data.data;
        });
        this.actiontype=params.action;
        if (params.action != "useradd") {
            this.$store.dispatch({
                type: "alarmmanager/userdetails",
                params: query,
                showMsg: false
            }).then((res)=>{
                this.groupidlist = res.data.data.groupid;
                this.getSearchGroupList();
            });
        }
    },
    components: {
        commonselecter
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
.form_span{
    font-size: 14px;
    font-weight: bolder;
}
</style>
